import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import LoadingBoundary from '~/src/components/LoadingBoundary';
import BaseTabs from '~/src/components/Tabs';
import { OtePlayer } from '~/src/models/OtePlayer';
import { OteTeam } from '~/src/models/OteTeam';
import Biography from './Biography';
import Season from './Season';
import Seasons from './Seasons';
import './Tabs.scss';

const Tabs = ({ player, team }: { player: OtePlayer; team: OteTeam }) => {
	const { section } = useParams();
	const seasons = _.orderBy(
		player.ote_seasons_ote_players.filter((ps) => ps.ote_season.should_show_for_players),
		['ote_season.is_current', 'ote_season.starts_at'],
		['desc', 'asc'],
	);
	const seasonTabs = seasons.map((ps) => {
		return {
			name: ps.ote_season.name,
			text: ps.ote_season.name,
			component: <Season season={ps.ote_season} player={player} />,
		};
	});

	const playerTabs = [
		{ name: 'career', text: 'Career', component: <Seasons player={player} team={team} /> },
		,
		!_.isEmpty(player.biography) || !_.isEmpty(player.hero_image_path)
			? {
					name: 'biography',
					text: 'Biography',
					component: <Biography player={player} />,
				}
			: null,
	].filter(Boolean);

	const tabs: { name: string; text: string; component: JSX.Element }[] = [...seasonTabs, ...playerTabs];

	const defaultTab = section ? section : tabs[0].name;
	const [tabIndex, setTabIndex] = useState(tabs.findIndex((t) => t.name === defaultTab));
	const [tab, setTab] = useState(defaultTab);

	useEffect(() => {
		let index = tabs.map((t) => t.name).indexOf(tab);
		setTabIndex(index === -1 ? 0 : index);
	}, [tab]);

	return (
		<div className="PlayerProfileTabs">
			<div className="TabBar">
				<div className="TabContainer">
					<BaseTabs
						links={tabs.map((t) => [t.name, t.text])}
						section={tab}
						useCallback={(t) => setTab(t)}
						root={`/players/${player.id}`}
						useHistoryState={true}
					/>
				</div>
			</div>

			<div className="TabContent">
				<div className="TransitionContainer">
					<div
						className="ContentGrid"
						style={{ left: `${-100 * tabIndex}%`, gridTemplateColumns: '100%'.repeat(tabs.length) }}
					>
						{tabs.map((t) => {
							return (
								<div key={t.name} style={{ maxHeight: tab === t.name ? null : 0 }}>
									<LoadingBoundary errorComponent={<></>}>{t.component}</LoadingBoundary>
								</div>
							);
						})}
					</div>
				</div>
			</div>
		</div>
	);
};

export default Tabs;
